var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_732_5337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14L14 34L34 34V14L14 14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_732_5337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.043 15.666V20.666C20.043 21.0077 19.7596 21.291 19.418 21.291C19.0763 21.291 18.793 21.0077 18.793 20.666V15.666C18.793 15.3243 19.0763 15.041 19.418 15.041C19.7596 15.041 20.043 15.3243 20.043 15.666Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.043 29.0007V32.334C20.043 32.6757 19.7596 32.959 19.418 32.959C19.0763 32.959 18.793 32.6757 18.793 32.334V29.0007C18.793 28.659 19.0763 28.3757 19.418 28.3757C19.7596 28.3757 20.043 28.659 20.043 29.0007Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9583 25.6673C22.9583 27.6173 21.3667 29.209 19.4167 29.209C17.4667 29.209 15.875 27.6173 15.875 25.6673C15.875 23.7173 17.4667 22.1257 19.4167 22.1257C21.3667 22.1257 22.9583 23.7173 22.9583 25.6673ZM17.125 25.6673C17.125 26.934 18.15 27.959 19.4167 27.959C20.6833 27.959 21.7083 26.934 21.7083 25.6673C21.7083 24.4007 20.6833 23.3757 19.4167 23.3757C18.15 23.3757 17.125 24.4007 17.125 25.6673Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.207 15.6686V19.002C29.207 19.3436 28.9237 19.627 28.582 19.627C28.2404 19.627 27.957 19.3436 27.957 19.002V15.6686C27.957 15.327 28.2404 15.0436 28.582 15.0436C28.9237 15.0436 29.207 15.327 29.207 15.6686Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.207 27.334V32.334C29.207 32.6757 28.9237 32.959 28.582 32.959C28.2404 32.959 27.957 32.6757 27.957 32.334V27.334C27.957 26.9923 28.2404 26.709 28.582 26.709C28.9237 26.709 29.207 26.9923 29.207 27.334Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1263 22.3353C32.1263 24.2853 30.5346 25.877 28.5846 25.877C26.6346 25.877 25.043 24.2853 25.043 22.3353C25.043 20.3853 26.6346 18.7936 28.5846 18.7936C30.5346 18.7936 32.1263 20.3853 32.1263 22.3353ZM26.293 22.3353C26.293 23.602 27.318 24.627 28.5846 24.627C29.8513 24.627 30.8763 23.602 30.8763 22.3353C30.8763 21.0686 29.8513 20.0436 28.5846 20.0436C27.318 20.0436 26.293 21.0686 26.293 22.3353Z",
    fill: "#002857"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlueIcon);
export default __webpack_public_path__ + "static/media/filter_blue_icon.e60c974e93a89cd184971026823d9847.svg";
export { ForwardRef as ReactComponent };